
/**
 * Appends a suffix to the display name.
 *
 * @param {string} displayName - The display name.
 * @param {string} suffix - Suffix that will be appended.
 * @returns {string} The formatted display name.
 */
export function appendSuffix(displayName: string, suffix: string = '') {
    return `${displayName || suffix}${
        displayName && suffix && displayName !== suffix ? ` (${suffix})` : ''}`;
}

/**
 * Extracts the first name from a full name string.
 *
 * @param {string} fullName - The full name.
 * @returns {string} The first name.
 */
export function getFirstName(fullName = '') {
    return fullName
        .trim()
        .split(/\s+/)[0] || '';
}
